// Vendor imports
const { combineReducers } = require('redux-immutable')
// Entry imports
const IntoLandingRecord = require('client-v2/into-landing/state/record')

const reducers = {
  // Common state
  ...require('client-v2/common/state/reducers'),
  // Common containers
  authModal: require('client-v2/common/containers/auth-modal/reducer'),
  confirmModal: require('client-v2/common/containers/confirm-modal/reducer'),
  // Entry containers
  feed: require('client-v2/into-landing/pages/user-profile/containers/feed/reducer'),
  profileUser: require('client-v2/user-profile/containers/profile-user/reducer'),
  profileUserStats: require('client-v2/user-profile/containers/profile-user-stats/reducer'),
  smsModal: require('client-v2/into-landing/containers/sms-modal/reducer'),
  // No reducer; no actions are supported
  articleProfile: state => state,
  pageContext: state => state,
  posterUrl: state => state,
  topicProfile: state => state,
  videoUrl: state => state
}

module.exports = combineReducers(
  reducers,
  () => new IntoLandingRecord()
)
